/**
 * OAuth configuration for Google Cloud connection
 * Uses the same OAuth client ID as the backend
 */
export const oauthConfig = {
  google: {
    clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID || '',
  },
};
